import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PageTitle from "../../../components/page-title/PageTitle";

const Help = () => {
  return (
    <Container fluid className="dashboard-home-wrapper">
      <Row>
        <Col xs={12}>
          <PageTitle title="Help" />
        </Col>
        <Col xs={12}></Col>
      </Row>
    </Container>
  );
};

export default Help;
